import classNames from 'classnames'
import { useFormikContext } from 'formik'
import { isEmpty } from 'lodash'
import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

const InputFullTime = ({
  time,
  handleChange,
  showValidationErrors,
  isShorter,
  isActive,
  isLabel,
  dataCy,
}) => {
  const [hours, setHours] = useState('')
  const [minutes, setMinutes] = useState('')

  const { errors } = useFormikContext()
  const onChangeHour = (e) => {
    setHours(e.target.value)
  }

  const onChangeMinute = (e) => {
    setMinutes(e.target.value)
  }

  useEffect(() => {
    const hour = time?.slice(0, 2)
    const minute = time?.slice(3)

    if (!isActive) {
      setHours('')
      setMinutes('')
    } else {
      setHours(hour)
      setMinutes(minute)
    }
  }, [isActive])

  const correctHour = hours?.length === 1 ? `0${hours}` : hours

  const correctMinute =
    minutes?.length === 1 ? `0${minutes}` : minutes

  const correctTimeFormat =
    isEmpty(correctHour) || isEmpty(correctMinute)
      ? ''
      : `${correctHour}:${correctMinute}`

  const onBlurHour = () => {
    if (hours > 23) setHours('23')
    if (hours < 0) setHours('0')

    handleChange({
      fullTime: correctTimeFormat,
      hour: correctHour ?? '',
      minute: correctMinute ?? '',
    })
  }

  const onBlurMinute = () => {
    if (minutes > 59) setMinutes('59')
    if (minutes < 0) setMinutes('0')

    handleChange({
      fullTime: correctTimeFormat,
      hour: correctHour ?? '',
      minute: correctMinute ?? '',
    })
  }

  return (
    <div
      className={classNames('input-fullTime', {
        // refactor to make it more generic
        // shouldnt be errors.time
        // add prop with error
        '-error': showValidationErrors && errors?.time,
      })}
      data-testid="input-fullTime"
      data-cy={dataCy}
    >
      <div
        className={classNames('input-fullTime__wrapper', {
          '-shorter': isShorter,
        })}
      >
        <input
          className={classNames(
            'input-fullTime__input',
            { '-no-label': !isLabel },
            { '-non-active': !isActive },
            { '-shorter': isShorter }
          )}
          type="number"
          onChange={onChangeHour}
          onBlur={onBlurHour}
          value={hours}
          disabled={!isActive}
          data-testid="input-hours"
        />
        <label
          className={classNames(
            'input-fullTime__label',
            { '-shorter': isShorter },
            { '-isShort': !isEmpty(hours) },
            {
              '-error': showValidationErrors && errors?.time,
            }
          )}
        >
          {isLabel && 'Hour'}
        </label>
      </div>

      <span
        className={classNames('input-fullTime__colon', {
          '-non-active': !isActive,
        })}
      >
        :
      </span>

      <div
        className={classNames('input-fullTime__wrapper', {
          '-shorter': isShorter,
        })}
      >
        <input
          className={classNames(
            'input-fullTime__input',
            { '-no-label': !isLabel },
            { '-non-active': !isActive },
            { '-shorter': isShorter }
          )}
          type="number"
          onChange={onChangeMinute}
          onBlur={onBlurMinute}
          value={minutes}
          disabled={!isActive}
          data-testid="input-minutes"
        />
        <label
          className={classNames(
            'input-fullTime__label',
            { '-shorter': isShorter },
            { '-isShort': !isEmpty(minutes) },
            {
              '-error': showValidationErrors && errors?.time,
            }
          )}
        >
          {isLabel && 'Minute'}
        </label>
      </div>
    </div>
  )
}

InputFullTime.propTypes = {
  handleChange: PropTypes.func,
  time: PropTypes.string,
  showValidationErrors: PropTypes.bool,
  isShorter: PropTypes.bool,
  isActive: PropTypes.bool,
  isSetFieldValue: PropTypes.bool,
}

InputFullTime.defaultProps = {
  isShorter: false,
  isActive: true,
  isSetFieldValue: false,
  // handleChange: () => {},
}

export default InputFullTime
